import { getPathWithoutSearchParams, pathStartsWith } from '../../../helpers/path';
import { LEGAL_LINK } from '../../LegalLink/LegalLink';

export const isSettingsActive = (path = '') => {
  return (
    pathStartsWith(path) ||
    Object.values(LEGAL_LINK).map(getPathWithoutSearchParams).includes(window.location.pathname)
  );
};
